export interface ZealysLogin {
  id: string
  loginCode: string
  loginName: string
  email: string
  isSysAdmin: boolean
  roles: string[]
}

export interface LoginInternalAccess {
  id: string
  loginId: string
  loginCode: string
  loginName: string
  email: string
  role: string
  expiryDate: string | null
  grantedBy: string
  grantedDate: string
  notes: string
  isExpired: boolean
}

export interface GrantAccessRequest {
  loginId: string
  role: string
  expiryDate: string | null
  notes: string
}

export const InternalAccessRole = {
  WORKSPACE_ADMIN: 'workspace_admin',
  WORKSPACE_APPROVER: 'workspace_approver',
  WORKSPACE_USER: 'workspace_user',
  BILLING_ADMIN: 'billing_admin',
  BILLING_USER: 'billing_user',
  REQUESTER_SALES: 'requester_sales',
  REQUESTER_CONSULTANT: 'requester_consultant',
  REQUESTER_FINANCE: 'requester_finance'
} as const

export type InternalAccessRoleValue = (typeof InternalAccessRole)[keyof typeof InternalAccessRole]

export const roleLabels: Record<InternalAccessRoleValue, string> = {
  [InternalAccessRole.WORKSPACE_ADMIN]: 'Workspace admin',
  [InternalAccessRole.WORKSPACE_APPROVER]: 'Workspace approver',
  [InternalAccessRole.WORKSPACE_USER]: 'Workspace user',
  [InternalAccessRole.BILLING_ADMIN]: 'Billing admin',
  [InternalAccessRole.BILLING_USER]: 'Billing user',
  [InternalAccessRole.REQUESTER_SALES]: 'Requester (Sales)',
  [InternalAccessRole.REQUESTER_CONSULTANT]: 'Requester (Consultant)',
  [InternalAccessRole.REQUESTER_FINANCE]: 'Requester (Finance)'
}

export function formatRole(role: string): string {
  return roleLabels[role as InternalAccessRoleValue] || role
}

export function getRoleCategory(role: string): 'workspace' | 'billing' | 'requester' | null {
  if (role.startsWith('workspace_')) return 'workspace'
  if (role.startsWith('billing_')) return 'billing'
  if (role.startsWith('requester_')) return 'requester'
  return null
}
